import React from 'react';
import './style.css';

const MostraEstrelas = ({ total, cinco, quatro, tres, dois, um }) => {
    const calculaPorcentagem = (quantidade) => {
        return total > 0 ? ((quantidade / total) * 100).toFixed(2) : 0;

    };

    const renderBarra = (quantidade, estrelas) => {
        const porcentagem = calculaPorcentagem(quantidade);
        return (
            <div className="mostra-estrelas-barra">
                <div className="mostra-estrelas-header">
                    <span>{estrelas} estrelas</span>
                    <span>{porcentagem}%</span>
                </div>
                <div className="mostra-estrelas-container">
                    <div
                        className="mostra-estrelas-preenchido"
                        style={{ width: `${porcentagem}%` }}
                    ></div>
                </div>
            </div>
        );
    };

    return (
        <div className='mostra-estrelas-render-container mostra-estrelas-render' 
        >
            {renderBarra(cinco, 5)}
            {renderBarra(quatro, 4)}
            {renderBarra(tres, 3)}
            {renderBarra(dois, 2)}
            {renderBarra(um, 1)}
        </div>
    );
};

export default MostraEstrelas;